import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { filter } from 'rxjs/operators';
import { StorageService } from 'src/assets/lib/eaf-ng2-module';
import { AppConsts } from 'src/shared/AppConsts';
import { AppComponentBase } from 'src/shared/common/app-component-base';
import { AppAuthenticationService } from 'src/shared/common/auth/app-authentication-service';
import { NameValueDto } from 'src/shared/service-proxies/service-proxies';

import { CommonLookupModalComponent } from './shared/common/lookup/common-lookup-modal.component';
import { LoginAttemptsModalComponent } from './shared/layout/login-attempts-modal.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { ChangePasswordModalComponent } from './shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from './shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from './shared/layout/profile/my-settings-modal.component';

/* eslint-disable @typescript-eslint/ban-types */
declare let gtag: Function;

@Component({ standalone: false, templateUrl: './app.component.html' })
export class AppComponent extends AppComponentBase implements OnInit, AfterViewInit {
  theme: string;
  chatConnected = false;

  @ViewChild('loginAttemptsModal', { static: true }) loginAttemptsModal: LoginAttemptsModalComponent;
  @ViewChild('changePasswordModal', { static: true }) changePasswordModal: ChangePasswordModalComponent;
  @ViewChild('changeProfilePictureModal', { static: true }) changeProfilePictureModal: ChangeProfilePictureModalComponent;
  @ViewChild('mySettingsModal', { static: true }) mySettingsModal: MySettingsModalComponent;
  @ViewChild('notificationSettingsModal', { static: true }) notificationSettingsModal: NotificationSettingsModalComponent;
  @ViewChild('userLookupModal', { static: true }) userLookupModal: CommonLookupModalComponent;

  public constructor(
    injector: Injector,
    private _userNotificationHelper: UserNotificationHelper,
    private _appAuthenticationService: AppAuthenticationService,
    private _storageService: StorageService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
    this.theme = eaf.setting.get('App.UiManagement.Theme').toLocaleLowerCase();

    this.registerModalOpenEvents();

    this.setUpAnalytics();
    this.setUpTagManager();
  }

  ngAfterViewInit(): void {
    this._appAuthenticationService.init();
  }

  setUpAnalytics(): void {
    if (AppConsts.googleAnalytics !== undefined) {
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        gtag('config', AppConsts.googleAnalytics, { page_path: event.urlAfterRedirects });
        gtag('set', 'page', event.urlAfterRedirects);
        gtag('send', 'pageview');
      });
    }
  }

  setUpTagManager(): void {
    if (AppConsts.googleTagManager !== undefined) {
      this.router.events.forEach(item => {
        if (item instanceof NavigationEnd) {
          const gtmTag = {
            event: 'page',
            pageName: item.url,
          };
          this.gtmService.pushTag(gtmTag);
        }
      });
    }
  }

  registerModalOpenEvents(): void {
    eaf.event.on('app.show.loginAttemptsModal', () => {
      this.loginAttemptsModal.show();
    });

    eaf.event.on('app.show.changePasswordModal', () => {
      this.changePasswordModal.show();
    });

    eaf.event.on('app.show.changeProfilePictureModal', () => {
      this.changeProfilePictureModal.show();
    });

    eaf.event.on('app.show.mySettingsModal', () => {
      this.mySettingsModal.show();
    });
    eaf.event.on('app.chat.connected', () => {
      this.chatConnected = true;
    });
  }

  onMySettingsModalSaved(): void {
    eaf.event.trigger('app.onMySettingsModalSaved');
  }

  addFriendSelected(item: NameValueDto): void {
    eaf.event.trigger('app.chat.addFriendSelected', item);
  }
}
